import { Grid, TextField } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { basic, validationMessages } from '../../../config/validations';
import { toggleRightDrawer, setFocusElement, setReRender } from '../../../store/global/actions';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import {IconSelector} from "../../atoms/IconSelectorV2";
import { invokeGetService, invokePostService } from '../../../store/global/actions'
import { findIconSource, formatFetchedCustomIcons, generateIconFileName } from '../../../utils/commonUtils';

export default function EditUser(props) {

    const { element, onCompletion, onClose } = props;
    const dispatch = useDispatch();

    const [user, setUser] = useState(element);
    const [icon, setIcon] = useState(null);
    const [prevIcon, setPrevIcon] = useState("");
    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState: { errors }, reset, setError, watch } = useForm({
        defaultValues: {
            name: user?.name,
            description: user?.desc
        }
    });

    const nameValue = watch("name");

    useEffect(() => {
        // setIcon(element?.icon);
        dispatch(invokeGetService('getClusterlet', [element.id])).then(res => {
           if(res?.status == true){
            setUser(res?.data);
            setIcon(formatFetchedCustomIcons(res?.data));
            setPrevIcon(res?.data?.icon);
            reset({
                name: res?.data?.name,
                description: res?.data?.attributes?.desc
            });
           } else {
            if (res?.code === 255) {
                dispatch(toggleRightDrawer());
                dispatch(setReRender());
                dispatch(setFocusElement({}));
            }
           }
        })
    }, [])
    const cancelUpdation = () => {
        dispatch(toggleRightDrawer())
    }

    const onUpdate = ({ name, description }) => {
        const updatedSensorInfo = {
            name,
            attributes: {
                ...user.attributes,
                desc: description
            }, 
            type: 20
        }
        if(prevIcon != generateIconFileName(icon)){
            updatedSensorInfo.icon =  generateIconFileName(icon);
            updatedSensorInfo.iconSource =  findIconSource(icon);
        }

        setLoading(true);
        dispatch(invokePostService('editClusterlet', {clusterlet: updatedSensorInfo}, [element.id])).then(res => { 
			setLoading(false);
			if (res?.status === true) {
                if(user.name !== name) {
                    dispatch(setFocusElement({ id: user._id, type: 'user', templateId: '', name: name, icon: user?.icon, desc: user?.attributes?.desc }));
                }
                onCompletion('Enterprise App', 'edit');
                onClose();
			} else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
		});
    }

    const messages = { ...validationMessages, validate: 'This name is already used' };


    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="description"
                    type={"text"}
                    fullWidth
                    rows={2}
                    maxRows={2}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register({ required: false })}
                    multiline={true}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", marginBottom: 20 }}>
                <IconSelector selectedIcon={icon} setSelectedIcon={setIcon} defaultSearchTag={nameValue}/>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <UpdateCancel updateDisable={loading} content={loading ? 'Updating..' : 'Update'} onUpdate={handleSubmit(onUpdate)} onCancel={cancelUpdation} typesNotIn={['transaction', 'view']}/>
            </Grid>

        </Grid>

    )
}
